(function () {
    'use strict';

    angular.module('gatewayApp').service('CryptoUtil', CryptoUtil);

    function CryptoUtil() {

        // Base64 encoded AES key
        var cryptoKey = CryptoJS.enc.Base64.parse("MTIzNDU2Nzg5MDEyMzQ1Ng==");

        // 16-byte IV
        var iv = CryptoJS.enc.Utf8.parse("1234567890123456");

        var service = {
            encrypt: encrypt,
            decrypt: decrypt
        };

        return service;

        function encrypt(message, key) {

            if (key !== undefined) {
                cryptoKey = CryptoJS.enc.Base64.parse(key);
            }

            var encrypted = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(message),
                cryptoKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            return encrypted.toString();
        }

        function decrypt(cipherText, key) {

            if (key !== undefined) {
                cryptoKey = CryptoJS.enc.Base64.parse(key);
            }

            var decrypted = CryptoJS.AES.decrypt(
                cipherText,
                cryptoKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            return decrypted.toString(CryptoJS.enc.Utf8);
        }
    }
})();